import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Card from "react-bootstrap/Card";
import { ProjectManufacturesQuotations } from "../../Model/Projects/ProjectManufacturesQuotations";
import CustomDataTable from "../../Components/CustomDataTable";
import { TableColumn } from "react-data-table-component";
import { fetchData } from "../../Util/OrionList";
import { useLocation, useNavigate } from "react-router-dom";
import { setToast } from "../../Util/Toast";
import CustomViewButton from "../../Components/Button/CustomViewButton";
import { PROJECTS_MANUFACTURER_QUOTATION_REQUESTS_VIEW } from "../../Routes/Project/Project";
import ConfirmationModal from "../../Components/ConfirmationModel";
import { CapitalizeAndRemoveUnderscore } from "../../Util/CapitalizeAndRemoveUnderscore";

const QuotationRequestsCard = ({ permissions }: any) => {
  const { id }: any = useParams();
  const location = useLocation(); // Use useLocation hook here
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [customSubmitting, setCustomSubmitting] = useState(false); // State variable to track form submission status
  const [limit, setLimit] = useState(
    Number(searchParams.get("perPage")) === 0
      ? 10
      : Number(searchParams.get("perPage")),
  );
  const [page, setPage] = useState(
    Number(searchParams.get("page")) === 0
      ? 1
      : Number(searchParams.get("page")),
  );
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [sortField, setSortField] = useState<string>("id");
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [isArchive, setIsArchive] = useState<boolean>(false);
  const [includeWith] = useState(["projectManufactures.supplier"]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedQuotationStatus, setSelectedQuotationStatus] = useState<any>(
    {},
  );

  const sendQuotation = async (Id: any, status: any) => {
    try {
      setCustomSubmitting(true);
      const formdata: any = {
        id: Id,
        status,
      };
      let item: any = await ProjectManufacturesQuotations.$query().find(Id);
      item.$attributes = item.$attributes.id;
      item.$attributes = {
        ...item.$attributes.id,
        ...formdata,
      };
      item = await item.$save();
      await fetchQuotationRequests();
    } catch (error: any) {
      if (error.response?.data?.message) {
        setToast("error", error.response.data.message);
      } else {
        setToast("error", "An error occurred while processing your request");
      }
    } finally {
      setCustomSubmitting(false);
    }
  };

  const copyLink = (data: any) => {
    const link = `${process.env.REACT_APP_URL}project-quotation-public/${data.token}`;
    navigator.clipboard.writeText(link);
    setToast("success", "Link copied to clipboard");
  };
  const openViewPage = (qid: any, mid: any) => {
    navigate(
      PROJECTS_MANUFACTURER_QUOTATION_REQUESTS_VIEW.replace(
        ":id",
        id.toString(),
      )
        .replace(":qid", qid.toString())
        .replace(":mid", mid.toString()),
    );
  };
  const handleQuotationStatusChange = (quotationId: any, status: any) => {
    if (quotationId && status) {
      setSelectedQuotationStatus({ quotationId, status });
      setShowConfirmationModal(true);
    }
  };
  const handleConfirmation = async (status: any) => {
    await sendQuotation(status.quotationId, status.status);
    setShowConfirmationModal(false);
  };

  const columns: TableColumn<any>[] = [
    {
      name: "Id",
      maxWidth: "1%",
      cell: (row: any) => row.id,
    },
    {
      name: "Status",
      // width: "10%",
      cell: (row: any) => CapitalizeAndRemoveUnderscore(row.status),
    },
    {
      name: "Manufacturer Name",
      width: "15%",
      cell: (row: any) => row.project_manufactures.supplier.company_name,
    },
    {
      name: "Quotation",
      width: "15%",
      cell: (row) => (
        <div className="">
          <select
            style={{ boxShadow: "none" }}
            className="form-select border-0"
            value={row.status} // Assuming row.status holds the current status
            onChange={(e) =>
              handleQuotationStatusChange(row.id, e.target.value)
            }
          >
            <option value="">Select Option</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      ),
    },
    {
      name: "Created At",
      width: "10%",
      cell: (row: any) => row.created_at,
    },
    {
      style: { justifyContent: "center" },
      button: false,
      width: "35%",
      cell: (row) => (
        <div className="d-flex justify-content-end align-items-center">
          <button
            type="button"
            // className="btn btn-danger me-3"
            style={{ width: "85px", height: "max-content" }}
            className={`btn-sm me-3
            ${row.status === "draft" ? "btn btn-danger" : "btn btn-warning"}`}
            onClick={() => {
              sendQuotation(row.id, "sent");
            }}
          >
            {row.status === "draft" ? "Send" : "Resend"}
          </button>
          <button
            type="button"
            style={{ width: "130px", height: "max-content" }}
            className={`btn-sm me-3
              ${
                row.status === "sent" ? "btn btn-primary" : "btn btn-secondary"
              }`}
            onClick={() => {
              sendQuotation(row.id, "revoke_access");
            }}
            disabled={row.status === "sent" ? false : true}
          >
            Revoke Access
          </button>
          <button
            type="button"
            style={{ width: "auto", height: "max-content" }}
            // className="btn btn-success me-5 btn-sm"
            className={`btn btn-sm me-3
              ${row.status === "sent" ? "btn-success" : "btn btn-secondary"}`}
            onClick={() => {
              copyLink(row);
            }}
            disabled={
              row.status === "revoke_access" ||
              row.status === "submitted" ||
              row.status !== "sent"
                ? true
                : false
            }
          >
            Copy Link
          </button>
          {/* {row.status !== "draft" && row.status !== "sent" && (
            <CustomViewButton
              id={row.id}
              onClick={(e) => {
                openViewPage(row.id);
              }}
            />
          )} */}
        </div>
      ),
    },
    {
      name: "Actions",
      button: false,
      // width: "8%",
      cell: (row) => (
        <div className="">
          {row.status !== "draft" && row.status !== "sent" && (
            <CustomViewButton
              id={row.id}
              onClick={(e) => {
                openViewPage(row.id, row.project_manufactures.id);
              }}
              customFill={"green"}
            />
          )}
        </div>
      ),
    },
  ];
  const handlePerRowsChange = async (rowLimit: any, page: any) => {
    if (limit === rowLimit) {
      setLimit(rowLimit);
      setPage(page);
    } else {
      setLimit(rowLimit);
      setPage(1);
    }
  };

  const handlePageChange = (page: any) => {
    setPage(page);
  };
  const handleRowCreateButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
  };

  useEffect(() => {
    setSortField("id");
    setSortOrder("desc");
    setIsArchive(false);
    fetchQuotationRequests();
  }, [isArchive, limit, page]); // eslint-disable-line
  const fetchQuotationRequests = async () => {
    setLoading(true);
    try {
      setLoading(true);
      await fetchData(
        page,
        limit,
        { project_id: { value: id } },
        // inputValues,
        setLoading,
        setData,
        setTotalRows,
        navigate,
        new ProjectManufacturesQuotations(),
        sortField,
        sortOrder,
        isArchive,
        includeWith,
      );
      setLimit(limit);
      setLoading(false);
    } catch (error: any) {
      setToast("error", error.response.data.message);
    }
  };

  return (
    <>
      <div className="row py-4">
        <h2>Quotation Requests</h2>
        <Card>
          <Card.Body>
            <CustomDataTable
              columns={columns}
              data={data}
              progressPending={loading}
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              handleRowCreateButtonClick={handleRowCreateButtonClick}
              currentPages={page}
              currentRowsPerPage={limit}
              customSkeletonCount={0}
            />
          </Card.Body>
        </Card>
      </div>

      <ConfirmationModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        title="Confirmation"
        message={`Are you sure you want to ${
          selectedQuotationStatus.status === "approved"
            ? "approve"
            : selectedQuotationStatus.status === "rejected"
            ? "reject"
            : ""
        } this quotation?`}
        onConfirm={() => handleConfirmation(selectedQuotationStatus)}
        confirmButtonColor={
          selectedQuotationStatus.status === "approved"
            ? "success"
            : selectedQuotationStatus.status === "rejected"
            ? "danger"
            : "primary"
        }
        spinnerStatus={customSubmitting ? customSubmitting : false}
      />
    </>
  );
};

export default QuotationRequestsCard;
